
import { defineComponent, useMeta } from '@nuxtjs/composition-api'
import { truncate, stripTags } from '@zicht/nuxt-util'
import { getMediaSeoImage } from '~/assets/media'
import { setupTranslationPrefixer } from '~/assets/translation'

export default defineComponent({
  props: {
    page: { type: Object, required: true },
  },
  setup(props) {
    // Build the Schema.org data
    const schemaData = {
      '@context': 'https://schema.org/',
      '@type': 'Person',
      url: props.page.url,
      name: [props.page.firstName, props.page.insertion, props.page.lastName].filter((n) => n).join(' '),
      email: props.page.emailAddressOverride || props.page.emailAddress,
      familyName: [props.page.insertion, props.page.lastName].filter((n) => n).join(' '),
      givenName: props.page.firstName,
      jobTitle: props.page.profession,
      image: getMediaSeoImage(props.page.photo).url,
      telephone: props.page.phoneNumber,
    }
    useMeta({
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ type: 'application/ld+json', innerHTML: JSON.stringify(schemaData) }],
    })

    return {
      truncate,
      stripTags,
      ...setupTranslationPrefixer('person-page'),
    }
  },
  head: {},
  methods: {
    getCallablePhoneNumber(phoneNumber) {
      // Strip spaces and other characters, except digits 0-9 and the plus sign for net numbers.

      if (phoneNumber !== null) {
        phoneNumber = phoneNumber.replace(/\s/g, '')

        if (phoneNumber.charAt(0) === '+' && phoneNumber.includes('(0)')) {
          // Net number is present, remove excessive '(0)' if present at the same time
          const index = phoneNumber.indexOf('(0)')
          phoneNumber = phoneNumber.slice(0, index) + phoneNumber.slice(index + 3)
        }

        phoneNumber = phoneNumber.replace(/[^+0-9]/g, '')

        return phoneNumber
      }
    },
    convertLinebreaksToBreakTag(text) {
      if (!text) {
        return ''
      }

      return text.replace(/\n/g, '<br />')
    },
    getLangAttributeForPublication(publication) {
      if (publication.type === 'publicationEntry' && this.page.language === 'nl' && publication.publicationLanguage === 'English') {
        return 'en'
      }
      return undefined
    },
  },
})
